<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8.62292V18.4286C0 19.338 0.361224 20.21 1.00421 20.853C1.64719 21.496 2.51926 21.8572 3.42857 21.8572H20.5714C21.4807 21.8572 22.3528 21.496 22.9958 20.853C23.6388 20.21 24 19.338 24 18.4286V8.62292L13.7966 14.9006C13.2563 15.233 12.6344 15.409 12 15.409C11.3656 15.409 10.7437 15.233 10.2034 14.9006L0 8.62292Z"
      :fill="color"
    />
    <path
      d="M24 6.60914V6.42857C24 5.51926 23.6388 4.64719 22.9958 4.00421C22.3528 3.36122 21.4807 3 20.5714 3H3.42857C2.51926 3 1.64719 3.36122 1.00421 4.00421C0.361224 4.64719 0 5.51926 0 6.42857V6.60914L11.1017 13.4411C11.3719 13.6073 11.6828 13.6953 12 13.6953C12.3172 13.6953 12.6281 13.6073 12.8983 13.4411L24 6.60914Z"
      :fill="color"
    />
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: "#98A2B3",
  },
});
</script>
